import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Card, Col, Form, Row } from 'react-bootstrap'

import {
    faEye,
    faPen,
    faPlus,
    faSave,
    faTimes,
    faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Address from '@component/Address'
import Breadcrumb from '@component/Breadcrumb'
import Contact from '@component/Contact'
import Modal from '@component/Modal'
import TableFixed from '@component/TableFixed'
import TypePerson from '@component/TypePerson'


const breadcrumbItems = [
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Clientes', url: '/customers' },
    { title: 'Cadastrar' }
]

const tableItemsTitleAddress = [
    { title: 'Tipo de Endereço', align: 'left' },
    { title: 'CEP', align: 'left' },
    { title: 'Logradouro', align: 'left' },
    { title: 'Complemento', align: 'left' },
    { title: 'Bairro', align: 'left' },
    { title: 'Cidade/UF', align: 'left' },
    { title: 'Referência', align: 'left' },
    { title: 'Ação', align: 'center' },
]

const tableItemsDataAddress = [
    {
        type_address: 'Residência',
        zipcode: '14620-000',
        address: 'Avenida O, 519',
        complement: 'A',
        neighborhood: 'Jardim Santo Expedido',
        city_state: 'Orlândia/SP',
        reference: '-',
        action: (
            <>
                <button className='btn'>
                    <FontAwesomeIcon icon={faEye} />
                </button>

                <button className='btn'>
                    <FontAwesomeIcon icon={faPen} />
                </button>

                <button className='btn'>
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </>
        )
    }
]

const tableItemsTitleContact = [
    { title: 'Tipo de Contato' },
    { title: 'Contato' },
    { title: 'Ação' },
]

const tableItemsDataContact = [
    {
        type_contact: 'E-mail',
        contact: 'villa.eduardobarros@gmail.com',
        action: (
            <>
                <button className='btn'>
                    <FontAwesomeIcon icon={faPen} />
                </button>

                <button className='btn'>
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </>
        )
    },
    {
        type_contact: 'Celular',
        contact: '16 99104.3081',
        action: (
            <>
                <button className='btn'>
                    <FontAwesomeIcon icon={faPen} />
                </button>

                <button className='btn'>
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </>
        )
    }
]


export default function UsersForm() {

    const { co_customer } = useParams()

    const [showModal, setShowModal] = useState({
        show: true,
        title: 'Carregando...',
        component: null
    })
    const [type_person, setTypePerson] = useState(1)

    const hundleGetModal = (show) => { setShowModal(show) }

    const addContact = () => {
        setShowModal((prevState) => ({
            ...prevState,
            show: true,
            size: 'lg',
            title: 'Cadastrar Contato',
            component: <Contact callbackParentModal={hundleGetModal} id={co_customer} />
        }))
    }

    const addAddress = () => {
        setShowModal((prevState) => ({
            ...prevState,
            show: true,
            size: 'lg',
            title: 'Cadastrar Endereço',
            component: <Address callbackParentModal={hundleGetModal} id={co_customer} />
        }))
    }

    function sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time))
    }

    useEffect(() => {
        sleep(2000).then(() => {
            setShowModal((prevState) => ({ ...prevState, show: false }))
        })
    }, [])


    return (

        <>

            <div className='header' id='customer_form'>
                <h1 className='header-title'>
                    {co_customer ? `Alterar dados do cliente - #${co_customer}` : `Cadastrar novo cliente`}
                </h1>
                <Breadcrumb breadcrumb={breadcrumbItems} />
            </div>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <Card.Body>

                            <Row className='mb-3'>
                                <Col lg={4}>
                                    <Form.Group>
                                        <Form.Label htmlFor='type_person'>Tipo de Pessoa</Form.Label>
                                        <div>
                                            <div className='btn-group btn-group-lg mb-3' role='group' aria-label='Large button group'>
                                                <button
                                                    type='button'
                                                    name='type_person'
                                                    className={`btn btn-lg btn-primary ${type_person === 1 ? 'active' : null}`}
                                                    defaultChecked={type_person === 1 ? true : false}
                                                    onClick={(e) => setTypePerson(1)}
                                                >Pessoa Física</button>

                                                <button
                                                    type='button'
                                                    name='type_person'
                                                    className={`btn btn-lg btn-primary ${type_person === 2 ? 'active' : null}`}
                                                    defaultChecked={type_person === 2 ? true : false}
                                                    onClick={(e) => setTypePerson(2)}
                                                >Pessoa Jurídica</button>
                                            </div>
                                        </div>
                                        <Form.Control type='hidden' name='type_person' value={type_person} />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {type_person ? <TypePerson type_person={type_person} id={co_customer} /> : null}

                            <Row className='mb-3'>
                                <Col lg={2}>
                                    <Form.Group>
                                        <Form.Label htmlFor='name'>Situação</Form.Label>
                                        <div className="form-check form-switch" style={{ padding: '0' }}>
                                            <span style={{ float: 'left', marginTop: '6px' }}>Bloqueado</span>
                                            <div className="form-check form-check-inline p-0" style={{
                                                float: 'left', margin: '0'
                                            }}>
                                                <input type="checkbox" className="form-check-input form-check-inline"
                                                    style={{ margin: '9px 14px 0', }} />
                                            </div>
                                            <span style={{ float: 'left', marginTop: '6px' }}>Liberado</span>
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <Card.Header>
                            <h4 className='float-start'>Contatos</h4>

                            <button
                                className='btn btn-primary float-end'
                                onClick={(e) => addContact()}
                                type='button'
                            >
                                <FontAwesomeIcon icon={faPlus} className='me-2' />
                                Adicionar contato
                            </button>
                        </Card.Header>
                        <Card.Body>

                            <TableFixed title={tableItemsTitleContact} data={tableItemsDataContact} />

                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <Card.Header>
                            <h4 className='float-start'>Endereços</h4>

                            <button
                                className='btn btn-primary float-end'
                                onClick={(e) => addAddress()}
                                type='button'
                            >
                                <FontAwesomeIcon icon={faPlus} className='me-2' />
                                Adicionar endereço
                            </button>
                        </Card.Header>
                        <Card.Body>

                            <TableFixed title={tableItemsTitleAddress} data={tableItemsDataAddress} />

                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <Card.Header>
                            <h4 className='float-start'>Outras informações</h4>
                        </Card.Header>
                        <Card.Body>

                            <Form.Control as="textarea" rows={4}></Form.Control>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className='mb-3'>
                <Col>
                    <Card>
                        <Card.Body>

                            <button
                                type='button'
                                className='btn btn-danger float-start'
                            >
                                <FontAwesomeIcon icon={faTimes} className='me-2' /> Cancelar
                            </button>

                            <button
                                type='submit'
                                className='btn btn-primary $ float-end'
                            >
                                <FontAwesomeIcon icon={faSave} className='me-2' /> Gravar
                            </button>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Modal state={showModal} />

        </>

    )
}